/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do women need a hip measurement?`)
};

const es_bf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué las mujeres necesitan medir la cadera?`)
};

const de_bf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum benötigen Frauen ein Hüftmaß?`)
};

const nl_bf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom hebben vrouwen een heupmaat nodig?`)
};

const fr_bf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les femmes ont-elles besoin d'une mesure de hanches ?`)
};

const it_bf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché le donne hanno bisogno della misura dei fianchi?`)
};

const pt_br2_bf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que as mulheres precisam medir o quadril?`)
};

const pt_bf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que as mulheres precisam da medida da anca?`)
};

const ja_bf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ女性はヒップ測定が必要なのですか?`)
};

const zh_bf_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么女性需要测量臀围？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_faq_q3", locale)
	if (locale === "en") return en_bf_faq_q3(inputs)
	if (locale === "es") return es_bf_faq_q3(inputs)
	if (locale === "de") return de_bf_faq_q3(inputs)
	if (locale === "nl") return nl_bf_faq_q3(inputs)
	if (locale === "fr") return fr_bf_faq_q3(inputs)
	if (locale === "it") return it_bf_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_bf_faq_q3(inputs)
	if (locale === "pt") return pt_bf_faq_q3(inputs)
	if (locale === "ja") return ja_bf_faq_q3(inputs)
	return zh_bf_faq_q3(inputs)
};